module.exports = __webpack_public_path__ + "d9fb8af3c5403f67a48604d3e062c693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing/med_student.jpg
// module id = 1084
// module chunks = 0